import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { get_summary_report, init_simulation } from '../services/api';
import { rootRoute } from "../../../config";
import { errorMsg } from "../../../helper/helpers";
import info from '../assets/info.png';
import General_feedback_active from "../assets/General_feedback_active.png";
import General_feedback_deactive from "../assets/General_feedback_deactive.png";
import Financial_analysis_active from "../assets/Finacial_analysis_active.png";
import Financial_analysis_deactive from "../assets/Financial_analysis_deactive.png";
import decision_analysis_active from "../assets/decision_analysis_active.png";
import decision_analysis_deactive from "../assets/decision_analysis_deactive.png";
import Button from '../../common/Button'
import leftArrow from "../assets/leftArrow.png";
import rightArrow from "../assets/rightArrow.png";
import prevArrow from "../assets/prevArrow.png";
import PmModuleStyle from '../styles/pm.module.css';
import AnalysisGraph from "./AnalysisGraph";
import TaskCostGraph from "./TaskCostGraph";
import TasktimeGraph from "./TasktimeGraph";
import MeanAPEGraph from "./MeanAPEGraph";
import DemandAnalysis from "./DemandAnalysis";

const Summary = () => {
  const location = useLocation();
  const navigate = useNavigate();
  var currentDate = new Date();
  var currentYear = currentDate.getFullYear();

  const queryParams = new URLSearchParams(location.search);

  const [summaryReports, setSummaryReports] = useState({});
  const [simulationDetailSummary, setSimulationDetailSummary] = useState([]);
  const [attempt, setAttempt] = useState(queryParams.get("attempt"));
  const [pagination, setPagination] = useState({ "prev": false, "next": false });
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError, error, simType, pmPopup, setPmPopup, setRelaunchPopup,focusPopUp,getTaskDataForGraph] = useOutletContext();
  const [isActive, setIsActive] = useState("generalFeedback");
  const [executioninstanceid, setExecutioninstanceid] = useState("");
  const [page, setPage] = useState(1);
  const [pageHeight, setPageHeight] = useState("");
  const summaryBtnStyle = { color: "white", borderRadius: "40px", margin: "0px", padding: "16px 55px", fontSize: "16px" };
  const noOfRatings = [1, 2, 3, 4, 5];
  const starRating = Number(summaryReports?.FinancialAnalysis?.starRating);
  const TargetSR = Number(summaryReports?.FinancialAnalysis?.targetStarRating);
  const [seriesStatus, setSeriesStatus] = useState([]);
  const [isStyleTagPresent, setIsStyleTagPresent] = useState(false); //Added for stylus tool text-spacing change
  let session_id = queryParams.get("sid");
  let resource_id = queryParams.get("resid");
  let course_id = queryParams.get("cid");
  let user_id = queryParams.get("userid");
  let attempt_id = queryParams.get("attempt");
  let role = queryParams.get("role");

  const formatNum = (number) => {
    let formattedNumber = number?.toString();
    formattedNumber = formattedNumber?.includes('.') ? formattedNumber?.replace(/\.?0*$/, '') : formattedNumber;
    return formattedNumber;
  }
  const checkNum = (num) => {
    return (!isNaN(num)) ? (num < 0
      ? `-$${Math?.abs(num)?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`
      : `$${num?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`) : "";
  };
  const handleSetActive = (e) => {
    const generalFeedbackOffset =
      document.getElementById(`${PmModuleStyle.generalFeedback}`).offsetTop - 20;
    const financialAnalysisOffset =
      document.getElementById(`financialAnalysis`).offsetTop - 20;
    const decisionAnalysisOffset =
      document.getElementById(`decisionAnalysis`).offsetTop - 20;

      if (e.type === "click") {
        if (e.currentTarget.classList.contains("generalFeedbackParent")) {
          document.getElementById(`${PmModuleStyle.generalFeedback}`).querySelector("h2").tabIndex = -1;
          document.getElementById(`${PmModuleStyle.generalFeedback}`).querySelector("h2").focus();
          if (document.querySelector(`.${PmModuleStyle['summary-content-box']}`) != null) {
            document.querySelector(`.${PmModuleStyle['summary-content-box']}`).scrollTop =
              generalFeedbackOffset - 20;
          }
        } else if (e.currentTarget.classList.contains("decisionAnalysisParent")) {
          document.querySelector(`#decisionAnalysis h2`).tabIndex = -1;
          document.querySelector(`#decisionAnalysis h2`).focus();
          if (document.querySelector(`.${PmModuleStyle['summary-content-box']}`) != null) {
            document.querySelector(`.${PmModuleStyle['summary-content-box']}`).scrollTop =
              decisionAnalysisOffset - 0;
          }
  
        } else if (
          e.currentTarget.classList.contains("financialAnalysisParent")
        ) {
          document.querySelector(`#financialAnalysis h2`).tabIndex = -1;
          document.querySelector(`#financialAnalysis h2`).focus();
          if (document.querySelector(`.${PmModuleStyle['summary-content-box']}`) != null) {
            document.querySelector(`.${PmModuleStyle['summary-content-box']}`).scrollTop =
              financialAnalysisOffset - 0;
          }
        }
      }
    const scrollPosition = e.currentTarget.scrollTop;

    if (
      scrollPosition >= generalFeedbackOffset &&
      scrollPosition < financialAnalysisOffset
    ) {
      document.querySelector(`.generalFeedbackParent `).blur();
      setIsActive("generalFeedback");
    } else if (
      scrollPosition >= financialAnalysisOffset &&
      scrollPosition < decisionAnalysisOffset
    ) {
      document.querySelector(`.financialAnalysisParent `).blur();
      setIsActive("financialAnalysis");
    } else if (scrollPosition >= decisionAnalysisOffset) {
      document.querySelector(`.decisionAnalysisParent `).blur();
      setIsActive("decisionAnalysis");
    }
  };
  const navigateToSimulation = () => {
    navigate(rootRoute + "/pm/simulation");
  };
  const handlePopupExitSim = (e) => {
    window.close();
  }
  const initSummary = () => {
    (simObj?.status != 'COMPLETED' && (attempt == undefined && user_id == undefined)) && navigate(`${rootRoute}/pm/simulation`);
    window.$("html, body").animate({ scrollTop: 0, }, 100);
  };
  const backToSimulationList = () => {
    setIsLoader(true);
    if (role == "student") {
      navigate(rootRoute + `/pm/studentreview?${queryParams}`);
    } else {
      navigate(rootRoute + `/pm/instructorreview?${queryParams}`);
    }
  }
  const getNextAttempt = () => {
    setIsLoader(true);
    let index = simulationDetailSummary?.findIndex((sdObj) => sdObj.attemptno == attempt);
    let currSdSObj = simulationDetailSummary[index + 1];
    if (currSdSObj != undefined) {
      setAttempt(currSdSObj.attemptno);
      queryParams.set("attempt", currSdSObj.attemptno);
      setExecutioninstanceid(currSdSObj?.executioninstanceid);
      (simulationDetailSummary[index + 2] != undefined) ? setPagination({ "prev": true, "next": false }) : setPagination({ "prev": false, "next": true });
    } else {
      setPagination({ "prev": false, "next": true });
      setIsLoader(false);
    }
  }
  const getPrevAttempt = () => {
    setIsLoader(true);
    let index = simulationDetailSummary?.findIndex((sdObj) => sdObj.attemptno == attempt);
    let currSdSObj = simulationDetailSummary[index - 1];
    if (currSdSObj != undefined) {
      setAttempt(currSdSObj.attemptno);
      queryParams.set("attempt", currSdSObj.attemptno);
      setExecutioninstanceid(currSdSObj?.executioninstanceid);
      (simulationDetailSummary[index - 2] != undefined) ? setPagination({ "prev": false, "next": false }) : setPagination({ "prev": true, "next": false });
    } else {
      setPagination({ "prev": true, "next": false });
      setIsLoader(false);
    }
  }
  const OnLoadPagination = () => {
    let lastObjIndex = simulationDetailSummary?.length - 1;
    let firstObjIndex = 0;
    let currentIndex = simulationDetailSummary?.findIndex((sdObj) => sdObj.attemptno == attempt);
    (currentIndex == lastObjIndex) && setPagination({ "prev": false, "next": true });
    (currentIndex == firstObjIndex) && setPagination({ "prev": true, "next": false });
    if ((currentIndex != lastObjIndex) && (currentIndex != firstObjIndex)) {
      setPagination({ "prev": false, "next": false });
    }
  }
  const getSimulationDetailSummary = () => {
    setSimulationDetailSummary((attempt != undefined && user_id != undefined) ? simObj?.simulationdetails : []);
    setIsLoader(false);
  };
  const updateExcutionInstanceId = () => {
    if (attempt != undefined && user_id != undefined) {
      setExecutioninstanceid(simulationDetailSummary?.filter((sdObj) => sdObj.attemptno == attempt)[0]?.executioninstanceid)
    } else {
      setExecutioninstanceid(simObj?.executioninstanceid)
    }
  }
  const getSummaryReport = () => {
    ((simObj?.sessionid != undefined || session_id != undefined) && executioninstanceid != undefined && executioninstanceid.length > 0) && get_summary_report((simObj?.sessionid || session_id), executioninstanceid).then(
      (response) => {
        if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
          setError(response?.data)
        }
        else{
        setSummaryReports(response?.data);
        //console.log(response.data)
        OnLoadPagination();
        setIsLoader(false);
        }
      }).catch((error) => {
        // setError(errorMsg);
        setError({"id":"00000","msg":errorMsg})
        console.log(error);
      });
  };
  const generalClickHandler = (e) => {
    if (window.innerWidth > 570) {
      e.preventDefault();
      document.querySelector(".generalFeedbackParent").click();
      e.stopPropagation();
    }
    return 0;
  }
  const financialClickHandler = (e) => {
    if (window.innerWidth > 570) {
      e.preventDefault();
      document.querySelector(".financialAnalysisParent").click();
      e.stopPropagation();
    }
    return 0;
  }
  const demandClickHandler = (e) => {
    if (window.innerWidth > 570) {
      e.preventDefault();
      document.querySelector(".decisionAnalysisParent").click();
      e.stopPropagation();
    }
    return 0;
  }
  useEffect(() => {
    setIsLoader(true);
    if (session_id != "" && simObj?.laststate == undefined) {//&& queryParams.get("sid") == undefined
      //setError(null);
      init_simulation(session_id).then(function (response) {
        // console.log(response.data);
        if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
          setError(response?.data)
        }
        else{
          setSimObj(Object.assign(response?.data, { "simulationdetails": simObj?.simulationdetails }));
          setError(null);
        }
      }).catch((error) => {
        // setError(errorMsg);
        setError({"id":"00000","msg":errorMsg})
      })
    }
    setIsOverlay(false);
  }, [])
  useEffect(() => { updateExcutionInstanceId(); }, [simulationDetailSummary])
  useEffect(() => { getSimulationDetailSummary(); }, [attempt])
  useEffect(() => { getSummaryReport(); }, [executioninstanceid])
  useEffect(() => {
    if(document.querySelector("header.header") != null){
      document.querySelector("header.header").style.display = "none";
    }
    if(document.querySelector(".App .row") != null){
      document.querySelector(".App .row").style.minHeight = "auto";
    }
    setIsLoader(true);
    initSummary();
    setAttempt(queryParams.get("attempt"))
    document.querySelector(`.${PmModuleStyle['summary-container']} header.header h1`).tabIndex = -1;
    document.querySelector(`.${PmModuleStyle['summary-container']} header.header h1`).focus();
    const summaryPageHeight = window.innerHeight - document.querySelector(`.${PmModuleStyle['summary-container']} header.header`).clientHeight - document.getElementsByClassName(`${PmModuleStyle['summary-footer']}`)[0].clientHeight - document.querySelector(`.footer`).clientHeight;
    setPageHeight(summaryPageHeight - 1);
    if (window.innerWidth <= 778 && window.innerHeight < 335) {
      setPageHeight(500);
    }

    document.title = "Project Management | Summary";

    if (attempt != undefined && user_id != undefined) {
      // if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
      //   document.querySelector("footer.footer .footer-nav .footer-links").style.display = "none";
      // }
      // if (document.querySelector("footer.footer .container") != null) {
      //   document.querySelector("footer.footer .container").style.justifyContent = "center";
      // }
      if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
        document.querySelector("footer.footer .footer-nav .footer-links").firstChild.style.display = "none";
      }
    }

    return () => {
      if(document.querySelector("header.header") != null){
        document.querySelector("header.header").style.display = "block";
      }
      if(document.querySelector(".App .row") != null){
        document.querySelector(".App .row").style.minHeight = "100vh";
      }
      if (attempt != undefined && user_id != undefined) {
        if (document.querySelector("footer.footer .footer-nav .footer-links") != null) {
          document.querySelector("footer.footer .footer-nav .footer-links").style.display = "block";
        }
        if (document.querySelector("footer.footer .container") != null) {
          document.querySelector("footer.footer .container").style.justifyContent = "space-between";
        }
      }

    };
  }, [simObj?.sessionid || session_id]);

  //Added for stylus tool
  useEffect(() => {
    const checkStyleTag = () => {
      const styleTag = document.querySelector('style.stylus');
      setIsStyleTagPresent(!!styleTag);  // Updates the state to true if the tag is found, false otherwise
    };
    checkStyleTag();
    // Optionally, if the tag might be dynamically added, use a MutationObserver or setInterval
    const intervalId = setInterval(checkStyleTag, 500); // Check every 500ms
    return () => clearInterval(intervalId);  // Clean up interval when component unmounts
  }, []);

  return (
    <motion.div className={`${PmModuleStyle['summary-container']}`}  id={`${isStyleTagPresent ? `${PmModuleStyle['pmSummaryStylus']}` : ''}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} >
      <header className={`header ${PmModuleStyle.header}`}>
        <div className={`container ${PmModuleStyle.container}`}>
          <div className={`${PmModuleStyle['icon-header-box']}`}>
            {
              (attempt != undefined && user_id != undefined) && <button onClick={backToSimulationList}><img src={prevArrow} /></button>
            }
            <h1 className={`ui header title ${PmModuleStyle.ui} ${PmModuleStyle.header} ${PmModuleStyle.title}`}>
              {attempt != undefined ? `Summary Report(Attempt ${attempt})` : "The project is completed! Review your results below."}
            </h1>
          </div>
          {
            (attempt != undefined && user_id != undefined && simulationDetailSummary?.length != 1) && <div className={`${PmModuleStyle['pagination-icons']}`}>
              <button disabled={pagination.prev} onClick={getPrevAttempt}><img src={leftArrow} /></button>
              <button disabled={pagination.next} onClick={getNextAttempt}><img src={rightArrow} /></button>
            </div>
          }
        </div>
      </header>
      <div className={`ui stackable two column grid ${PmModuleStyle.ui} ${PmModuleStyle.stackable} ${PmModuleStyle.column} ${PmModuleStyle.grid} ${PmModuleStyle['summary-content']} `}>
        <div className={`column ${PmModuleStyle.column} ${PmModuleStyle['navigation-tab']}`}>
          <ul className={`ui link list ${PmModuleStyle.ui} ${PmModuleStyle.link} ${PmModuleStyle.list}`}>
            <li className={`item generalFeedbackParent ${PmModuleStyle['item']} ${isActive === "generalFeedback" ? `${PmModuleStyle['active']}` : ""}`}
              onClick={(e) => {
                handleSetActive(e);
                setIsActive("generalFeedback");
                // e.target.focus();
                e.stopPropagation();
              }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  e.target.click();
                }
              }}
              // tabIndex={`${isActive === "generalFeedback" ? -1 : 0}`}
              tabIndex={0}
              >
              <a href={`#${PmModuleStyle.generalFeedback}`} onClick={generalClickHandler} tabIndex={-1}>
                <img src={isActive === "generalFeedback" ? General_feedback_active : General_feedback_deactive} alt="" />
                <span>GENERAL FEEDBACK</span>
              </a>
            </li>
            <li className={`item financialAnalysisParent ${PmModuleStyle['item']} ${isActive === "financialAnalysis" ? `${PmModuleStyle['active']}` : ""}`}
              onClick={(e) => {
                handleSetActive(e);
                setIsActive("financialAnalysis");
                // e.target.focus();
                e.stopPropagation();
              }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  e.target.click();
                }
              }}
              // tabIndex={`${isActive === "financialAnalysis" ? -1 : 0}`}
              tabIndex={0}>
              <a href={`#financialAnalysis`} onClick={financialClickHandler} tabIndex={-1}>
                <img src={isActive === "financialAnalysis" ? Financial_analysis_active : Financial_analysis_deactive} alt="" />
                <span>FINANCIAL ANALYSIS</span>
              </a>
            </li>
            <li className={`item decisionAnalysisParent ${PmModuleStyle['item']} ${isActive === "decisionAnalysis" ? `${PmModuleStyle['active']}` : ""}`}
              onClick={(e) => {
                handleSetActive(e);
                setIsActive("decisionAnalysis");
                // e.target.focus();
              }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  e.target.click();
                }
              }}
              // tabIndex={`${isActive === "decisionAnalysis" ? -1 : 0}`}
              tabIndex={0}>
              <a href={`#decisionAnalysis`} onClick={demandClickHandler} tabIndex={-1}>
                <img src={isActive === "decisionAnalysis" ? decision_analysis_active : decision_analysis_deactive} alt="" />
                <span>DECISION ANALYSIS</span>
              </a>
            </li>
          </ul>
        </div>
        <div className={`column ${PmModuleStyle.column} ${PmModuleStyle['summary-content-box']} `} onWheel={handleSetActive} style={{ height: pageHeight + "px" }} >
          <div className={`${PmModuleStyle.section}`} id={`${PmModuleStyle.generalFeedback}`} style={{ "marginTop": "0px" }}>
            <h2>General Feedback</h2>
            <table className={`ui unstackable table ${PmModuleStyle.ui} ${PmModuleStyle.unstackable} ${PmModuleStyle.table}`}>
            <thead>
              <tr>
                <th id="perMet" scope="col" className={`four wide ${PmModuleStyle.four} ${PmModuleStyle.wide}`}>
                  Performance Metric
                </th>
                {summaryReports?.GeneralFeedback?.last_projectCost !== "NA" ? (
                  <th id="prevSim" scope="col" className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                    Previous Simulation
                  </th>
                ) : 
                  // <th scope="col" className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                  // </th>
                  null
                }
                <th id="curSim" scope="col" className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                  Current Simulation
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th id="projCP" colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_projectCost !== "NA" ? 3 : 2} scope="row" className={`${PmModuleStyle['row-heading']}`}>
                  Project Cost and Profit
                </th>
              </tr>
              <tr className={`${PmModuleStyle['indent-row']}`}>
                <th headers="projCP" id="projC" className={`two wide ${PmModuleStyle.two} ${PmModuleStyle.wide}`}>Project Cost</th>
                {summaryReports?.GeneralFeedback?.last_projectCost !== "NA" ? (
                  <td headers="projCP projC prevSim"  className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                    {checkNum(Number(summaryReports?.GeneralFeedback?.last_projectCost))}
                  </td>
                ) : (
                  // <td className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}></td>
                  null
                )}
                {summaryReports?.GeneralFeedback?.projectCost !== "NA" && (
                  <td headers="projCP projC curSim" className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                    {checkNum(Number(summaryReports?.GeneralFeedback?.projectCost))}
                  </td>
                )}
              </tr>
              <tr className={`${PmModuleStyle['indent-row']}`}>
                <th headers="projCP" id="projA" className={`two wide ${PmModuleStyle.two} ${PmModuleStyle.wide}`}>Profit Achieved</th>
                {summaryReports?.GeneralFeedback?.last_projectCost !== "NA" ? (
                  <td headers="projCP projA prevSim" className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                    {checkNum(Number(summaryReports?.GeneralFeedback?.last_profitAchievedValue))}
                  </td>
                ) : (
                  // <td className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}></td>
                  null
                )}
                {summaryReports?.GeneralFeedback?.profitAchievedValue !== "NA" && (
                  <td headers="projCP projA curSim" className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                    {checkNum(Number(summaryReports?.GeneralFeedback?.profitAchievedValue))}
                  </td>
                )}
              </tr>
              <tr className={`${PmModuleStyle['indent-row']}`}>
                <th headers="projCP" id="projPer" className={`two wide ${PmModuleStyle.two} ${PmModuleStyle.wide}`}>Profit (In %)</th>
                {summaryReports?.GeneralFeedback?.last_projectCost !== "NA" ? (
                  <td headers="projCP projPer prevSim" className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                    {summaryReports?.GeneralFeedback?.last_profitPercentage}
                  </td>
                ) : (
                  // <td className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}></td>
                  null
                )}
                {summaryReports?.GeneralFeedback?.profitPercentage !== "NA" && (
                  <td headers="projCP projPer curSim" className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                    {summaryReports?.GeneralFeedback?.profitPercentage}
                  </td>
                )}
              </tr>
              <tr>
                <td className={`${PmModuleStyle['text-td']}`} colSpan={summaryReports?.GeneralFeedback?.last_projectCost !== "NA" ? 3 : 2}>
                  <p>{summaryReports?.GeneralFeedback?.profitAchieved}</p>
                </td>
              </tr>
              <tr>
                <th id="projStat" colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_projectCost !== "NA" ? 3 : 2} scope="row" className={`${PmModuleStyle['row-heading']}`}>
                  Project Status
                </th>
              </tr>
              <tr className={`${PmModuleStyle['indent-row']}`}>
                <th headers="projStat" id="projS" className={`two wide ${PmModuleStyle.two} ${PmModuleStyle.wide}`}>Project Status</th>
                {summaryReports?.GeneralFeedback?.last_projectCost !== "NA" ? (
                  <td headers="projStat projS prevSim" className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                    {summaryReports?.GeneralFeedback?.last_projectStatus.replaceAll("_", " ")}
                  </td>
                ) : (
                  // <td className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}></td>
                  null
                )}
                {summaryReports?.GeneralFeedback?.projectStatus !== "NA" && (
                  <td headers="projStat projS curSim" className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                    {summaryReports?.GeneralFeedback?.projectStatus.replaceAll("_", " ")}
                  </td>
                )}
              </tr>
              <tr>
                <th id="projTm" colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_projectCost !== "NA" ? 3 : 2} scope="row" className={`${PmModuleStyle['row-heading']}`}>
                  Project Time
                </th>
              </tr>
              <tr className={`${PmModuleStyle['indent-row']}`}>
                <th headers="projTm" id="projCT" className={`two wide ${PmModuleStyle.two} ${PmModuleStyle.wide}`}>Project Completion Time (In Days)</th>
                {summaryReports?.GeneralFeedback?.last_projectCost !== "NA" ? (
                  <td headers="projTm projCT prevSim" className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                    {summaryReports?.GeneralFeedback?.last_projectCompletionTime}
                  </td>
                ) : (
                  // <td className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}></td>
                  null
                )}
                {summaryReports?.GeneralFeedback?.projectCompletionTime !== "NA" && (
                  <td headers="projTm projCT curSim" className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                    {summaryReports?.GeneralFeedback?.projectCompletionTime}
                  </td>
                )}
              </tr>
              <tr>
                <td className={`${PmModuleStyle['text-td']}`} colSpan={summaryReports?.GeneralFeedback?.last_projectCost !== "NA" ? 3 : 2}>
                  <p>{summaryReports?.GeneralFeedback?.projectCompletion}</p>
                </td>
              </tr>
              <tr>
                <th id="homeMor" colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_projectCost !== "NA" ? 3 : 2} scope="row" className={`${PmModuleStyle['row-heading']}`}>
                  Homeowner Morale
                </th>
              </tr>
              <tr className={`${PmModuleStyle['indent-row']}`}>
                <th headers="homeMor" id="hMor" className={`two wide ${PmModuleStyle.two} ${PmModuleStyle.wide}`}>Homeowner Morale</th>
                {summaryReports?.GeneralFeedback?.last_projectCost !== "NA" ? (
                  <td headers="homeMor hMor prevSim" className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                    {summaryReports?.GeneralFeedback?.last_homeOwnerMoraleValue}
                  </td>
                ) : (
                  // <td className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}></td>
                  null
                )}
                {summaryReports?.GeneralFeedback?.homeOwnerMoraleValue !== "NA" && (
                  <td headers="homeMor hMor curSim" className={`three wide right aligned ${PmModuleStyle.three} ${PmModuleStyle.wide} ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                    {summaryReports?.GeneralFeedback?.homeOwnerMoraleValue}
                  </td>
                )}
              </tr>
              <tr>
                <td className={`${PmModuleStyle['text-td']}`} colSpan={summaryReports?.GeneralFeedback?.last_projectCost !== "NA" ? 3 : 2}>
                  <p>{summaryReports?.GeneralFeedback?.homeOwnerMorale}</p>
                </td>
              </tr>
              <tr>
                <th id="msgNotfn" colSpan={summaryReports?.GeneralFeedback != undefined && summaryReports?.GeneralFeedback?.last_projectCost !== "NA" ? 3 : 2} scope="row" className={`${PmModuleStyle['row-heading']}`}>
                  Messages and Notifications
                </th>
              </tr>
              <tr>
                <td headers="msgNotfn" className={`${PmModuleStyle['text-td']}`} colSpan={summaryReports?.GeneralFeedback?.last_projectCost !== "NA" ? 3 : 2}>
                  <p>
                    {summaryReports?.GeneralFeedback?.ReadArtifact}
                    {summaryReports?.GeneralFeedback?.RemaingArtifactVedict}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>

          </div>
          <div className={`${PmModuleStyle.section} ${PmModuleStyle['demand-analysis-div']}`} id={`financialAnalysis`}>
            <h2 className={`ui header ${PmModuleStyle.ui} ${PmModuleStyle.header}`}>Financial Analysis</h2>
            <div className={`ui stackable two column grid bordered ${PmModuleStyle.ui} ${PmModuleStyle.stackable} ${PmModuleStyle.column} ${PmModuleStyle.grid} ${PmModuleStyle.bordered}`}>
              <div className={`column ${PmModuleStyle.column} ${PmModuleStyle['table-block']}`}>
                <table className={`ui unstackable table ${PmModuleStyle.ui} ${PmModuleStyle.unstackable} ${PmModuleStyle.table}`}>
                  <tbody>
                    <tr>
                      <td>Total Sub Contract Cost </td>
                      <td className={`right aligned ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                        {checkNum(Number(summaryReports?.FinancialAnalysis?.totalSubContractorCost))}
                      </td>
                    </tr>
                    <tr>
                      <td>+ Total Expedite Cost </td>
                      <td className={`right aligned ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                        {checkNum(Number(summaryReports?.FinancialAnalysis?.totalExpediteCost))}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Total Project Cost</strong>
                      </td>
                      <td className={`right aligned ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                        <strong>
                          {checkNum(Number(summaryReports?.FinancialAnalysis?.totalSubContractorCost) + (summaryReports?.FinancialAnalysis?.totalExpediteCost))}
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <hr aria-hidden="true" role="presentation" />
                      </td>
                    </tr>
                    <tr>
                      <td>Project Budget</td>
                      <td className={`right aligned ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                        {checkNum(Number(summaryReports?.FinancialAnalysis?.projectBudget))}
                      </td>
                    </tr>
                    <tr>
                      <td>- Total Project Cost</td>
                      <td className={`right aligned ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                        {checkNum(Number(summaryReports?.FinancialAnalysis?.totalSubContractorCost) + (summaryReports?.FinancialAnalysis?.totalExpediteCost))}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Profit</strong>
                      </td>
                      <td className={`right aligned ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                        <strong>
                          {checkNum(Number(summaryReports?.FinancialAnalysis?.projectBudget) - ((summaryReports?.FinancialAnalysis?.totalSubContractorCost) + (summaryReports?.FinancialAnalysis?.totalExpediteCost)))}
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <hr aria-hidden="true" role="presentation" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Profit</strong>
                      </td>
                      <td className={`right aligned ${PmModuleStyle.right} ${PmModuleStyle.aligned}`}>
                        <strong>
                          {(((summaryReports?.FinancialAnalysis?.projectBudget) - ((summaryReports?.FinancialAnalysis?.totalSubContractorCost) + (summaryReports?.FinancialAnalysis?.totalExpediteCost))) / (summaryReports?.FinancialAnalysis?.projectBudget) * 100).toFixed(2)}%
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className={`column ${PmModuleStyle.column} ${PmModuleStyle['expense-graph-block']}`}>
                <AnalysisGraph summaryReports={summaryReports} id={"financialGraph"} title={"Total Project Cost"} aria-label={"Financial Analysis"}></AnalysisGraph>
                <div className={`${PmModuleStyle['totalprojectcost-legends']}`}>
                  <div className={`${PmModuleStyle['subcontratorcost']}`}><span className={`${PmModuleStyle['totalprojectpattern']}`} aria-hidden="true" role="presentation"><div className={`${PmModuleStyle['subcontrator-sign1']}`}></div></span>Total Sub Contractor Cost</div>
                  <div className={`${PmModuleStyle['expeditecost']}`}><span className={`${PmModuleStyle['totalprojectpattern']}`} aria-hidden="true" role="presentation"><div className={`${PmModuleStyle['expedite-legend-sign2']}`}></div></span>Total Expedite Cost</div>
                </div>
              </div>
            </div>

            <div className={`${PmModuleStyle['taskcost-graph-container']}`}>
              <TaskCostGraph simObj={simObj} isResult={true} summaryGraphData={summaryReports?.graphdata} setSimObj={setSimObj} attempt={attempt} seriesStatus={seriesStatus} setSeriesStatus={setSeriesStatus}></TaskCostGraph>
              <div className={`${PmModuleStyle['taskcostGraph-legend']}`} ><span className={`${PmModuleStyle['taskcost-legend1']} ${PmModuleStyle['taskcostpattern']}`} aria-hidden="true"><div className={`${PmModuleStyle['legend-sign1']}`}></div></span><div>Expected Task Cost</div> <span aria-hidden="true">&nbsp;&nbsp;</span><span className={`${PmModuleStyle['taskcost-legend2']} ${PmModuleStyle['taskcostpattern']}`} aria-hidden="true"><div className={`${PmModuleStyle['legend-sign2']}`}></div></span><div>Actual Task Cost</div></div>
            </div>

          </div>
          <div className={`${PmModuleStyle.section} ${PmModuleStyle['forecasting-analysis-div']}`} id={`decisionAnalysis`}>
            <h2 className={`ui header ${PmModuleStyle.ui} ${PmModuleStyle.header}`}>Decision Analysis</h2>
            <p className={`${PmModuleStyle['headtext-content']}`}>Decision accuracy takes into account both keeping project status on schedule and profit earned.</p>
            <div className={`ui stackable two column grid bordered ${PmModuleStyle.ui} ${PmModuleStyle.stackable} ${PmModuleStyle.column} ${PmModuleStyle.grid} ${PmModuleStyle.bordered}`}>
              <div className={`column ${PmModuleStyle.column} ${PmModuleStyle['decision-accuracy']}`}>
                <div className={`${PmModuleStyle['order-accuracy-container']}`}>
                  <div className={`${PmModuleStyle['icon-text-div']}`}>
                    <div className={`${PmModuleStyle['order-accuracy-graph']}`} decision-level={summaryReports?.DecisionAnalysis?.decisionAccuracy}>
                    </div>
                    <div className={`${PmModuleStyle['decision-level-text']}`}>
                      <h3>Decision Accuracy</h3>
                      <div>{summaryReports?.DecisionAnalysis?.decisionAccuracy}</div>
                    </div>
                  </div>
                  <p className={`${PmModuleStyle.content}`}>
                    {summaryReports?.DecisionAnalysis?.decisionAccuracyVedict}
                  </p>
                </div>
              </div>
              <div className={`column ${PmModuleStyle.column} ${PmModuleStyle['tasksstatus-graph']}`}>
                <AnalysisGraph summaryReports={summaryReports} id={"decisionGraph"} title={"Tasks Status"} ariaLabel={"Decision Analysis"}></AnalysisGraph>
                <div className={`${PmModuleStyle['taskStatus-legends']}`}>
                  <div className={`${PmModuleStyle['taskStatus-delay']}`}><span className={`${PmModuleStyle['taskstatuspattern']}`} aria-hidden="true" role="presentation"><div className={`${PmModuleStyle['Delayed-legend-sign1']}`}></div></span>Delayed</div>
                  <div className={`${PmModuleStyle['taskStatus-onschedule']}`}><span className={`${PmModuleStyle['taskstatuspattern']}`} aria-hidden="true" role="presentation"><div className={`${PmModuleStyle['Onschedule-legend-sign2']}`}></div></span>On Schedule</div>
                  <div className={`${PmModuleStyle['taskStatus-Aheadofschedule']}`}><span className={`${PmModuleStyle['taskstatuspattern']}`} aria-hidden="true" role="presentation"><div className={`${PmModuleStyle['Aheadofschedule-legend-sign3']}`}></div></span>Ahead of Schedule</div>
                </div>

              </div>
            </div>

            <div className={`${PmModuleStyle['tasktime-graph-container']}`}>
              <TasktimeGraph simObj={simObj} isResult={true} summaryGraphData={summaryReports?.graphdata} setSimObj={setSimObj} attempt={attempt} seriesStatus={seriesStatus} setSeriesStatus={setSeriesStatus} summaryReports={summaryReports} getTaskDataForGraph={getTaskDataForGraph}></TasktimeGraph>
              <div className={`${PmModuleStyle['taskcostGraph-legend']}`} ><span className={`${PmModuleStyle['taskcost-legend1']} ${PmModuleStyle['taskcostpattern']}`} aria-hidden="true"><div className={`${PmModuleStyle['legend-sign1']}`}></div></span><div>Expected Task Time</div> <span aria-hidden="true">&nbsp;&nbsp;</span><span className={`${PmModuleStyle['taskcost-legend2']} ${PmModuleStyle['taskcostpattern']}`} aria-hidden="true"><div className={`${PmModuleStyle['legend-sign2']}`}></div></span><div>Actual Task Time</div></div>
            </div>

          </div>
        </div>
        <div className={`${PmModuleStyle['summary-footer']}`}>
          {
            !(attempt != undefined && user_id != undefined) && <div className={`${PmModuleStyle['summary-btn-container']}`}>
              <Button btnName="BACK TO SIMULATION" btnId="backToSimulationBtn" customBtnStyle={summaryBtnStyle} clickEventHandler={navigateToSimulation} />
              {
                summaryReports.nextattempt ? (<Button btnName="START OVER" btnId="startOverBtn" customBtnStyle={summaryBtnStyle} clickEventHandler={startOverSimulation} />)
                  : (<span style={{ 'display': 'flex' }}><img src={info} alt="info" /><em>You do not have any remaining attempts.</em></span>)
              }
              <Button btnName="DONE" btnId="doneBtn" customBtnStyle={summaryBtnStyle} clickEventHandler={handlePopupExitSim} />
            </div>
          }
        </div>
      </div>
    </motion.div>
  );
};

export default Summary;